import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PartyProps } from "../../types/party";
import { GET } from "../../services/axios.service";
import { OrderItemProcessProps, OrderProps } from "../../types/order";

export interface NewOrderState {
  parties: PartyProps[];
  orders: OrderProps[];
  items: OrderItemProcessProps[];
  loading: boolean;
  error: string | null;
}

const initialState: NewOrderState = {
  parties: [],
  orders: [],
  items: [],
  loading: false,
  error: null,
};

export const fetchPartiesData = createAsyncThunk(
  "fetchPartiesData",
  async () => {
    let response: any;
    await GET(`/v1/worker/parties`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

type FetchItemsDataProps = {
  partyId: number;
};

export const fetchItemsData = createAsyncThunk(
  "fetchItemsData",
  async ({ partyId }: FetchItemsDataProps) => {
    let response: any;
    await GET(`/v1/worker/parties/${partyId}/items`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const newOrderSliceSlice = createSlice({
  name: "newOrderSlice",
  initialState,
  reducers: {
    updateOrdersData: (state, action: PayloadAction<OrderProps[]>) => {
      state.orders = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPartiesData.pending, (state, action: any) => {
      state.parties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPartiesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.parties = action.payload.data.data;
        state.error = null;
      } else {
        state.parties = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchPartiesData.rejected, (state, action: any) => {
      state.parties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });

    builder.addCase(fetchItemsData.pending, (state, action: any) => {
      state.items = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchItemsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.items = action.payload.data.data;
        state.error = null;
      } else {
        state.items = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchItemsData.rejected, (state, action: any) => {
      state.items = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { updateOrdersData } = newOrderSliceSlice.actions;

export const getParties = (state: RootState) => state.newOrder.parties;

export const getOrders = (state: RootState) => state.newOrder.orders;

export const getItems = (state: RootState) => state.newOrder.items;

export default newOrderSliceSlice.reducer;
